"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAddressUpdateDto = instanceOfAddressUpdateDto;
exports.AddressUpdateDtoFromJSON = AddressUpdateDtoFromJSON;
exports.AddressUpdateDtoFromJSONTyped = AddressUpdateDtoFromJSONTyped;
exports.AddressUpdateDtoToJSON = AddressUpdateDtoToJSON;
exports.AddressUpdateDtoToJSONTyped = AddressUpdateDtoToJSONTyped;
const State_1 = require("./State");
/**
 * Check if a given object implements the AddressUpdateDto interface.
 */
function instanceOfAddressUpdateDto(value) {
    return true;
}
function AddressUpdateDtoFromJSON(json) {
    return AddressUpdateDtoFromJSONTyped(json, false);
}
function AddressUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'line1': json['line1'] == null ? undefined : json['line1'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : (0, State_1.StateFromJSON)(json['state']),
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'zealWorkLocationId': json['zealWorkLocationId'] == null ? undefined : json['zealWorkLocationId'],
        'line2': json['line2'] == null ? undefined : json['line2'],
    };
}
function AddressUpdateDtoToJSON(json) {
    return AddressUpdateDtoToJSONTyped(json, false);
}
function AddressUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'line1': value['line1'],
        'city': value['city'],
        'state': (0, State_1.StateToJSON)(value['state']),
        'postalCode': value['postalCode'],
        'zealWorkLocationId': value['zealWorkLocationId'],
        'line2': value['line2'],
    };
}
//# sourceMappingURL=AddressUpdateDto.js.map